const isGlobal = process.env.GATSBY_STORE !== "PH" ? true : false;

export const navSwimMenu = [
	{ label: 'All Swim', url: '/collections/all' },
	{ label: 'New Arrivals', url: '/collections/new-arrivals' },
	{ label: 'Tops', url: '/collections/tops' },
	{ label: 'Bottoms', url: '/collections/bottoms' },
	{ label: 'One Piece', url: '/collections/one-piece-swimwear' },
	{ label: 'Solids', url: '/collections/solids' },
	{ label: 'Textured', url: '/collections/the-textured-collection' },
	{ label: 'Tankinis', url: '/collections/tankinis' },
]

export const navApparelMenu = [
	{ label: 'All Beachwear', url: '/collections/beachwear/' },
	{ label: 'All Accessories', url: '/collections/accessories' },
	{ label: 'Tanks & Tees', url: '/collections/tanks-tees' },
	{ label: 'Dresses & Skirts', url: '/collections/dresses-skirts' },
	{ label: 'Shorts', url: '/collections/shorts' },
	{ label: 'Bags', url: '/collections/bags' },
	{ label: 'Men\'s Collection', url: '/collections/mens-collection' },
	{ label: 'Matching Couple Suits', url: '/collections/his-hers' },
]

export const navCollectionMenu = [
	//{label: 'All Collections', url: '/collections/all'},
    ...(isGlobal ? [{ label: "Afterglow", url: "/collections/the-autumn-edit/" }] : []),
    { label: "Bridal Edit", url: "/collections/the-bridal-edit/" },
    { label: "Cleaner Coasts", url: "/collections/cleaner-coasts-2025/" },
    { label: "Club Voyages", url: "/collections/the-club-voyages-collection/" },
	{ label: "Patisserie", url: "/collections/the-patisserie-collection/" },
	{ label: "Sunchasers ☀", url: "/collections/the-ashley-kelly-edit-sunchasers/" },
	{ label: "Island Life ☀", url: "/collections/the-ashley-kelly-edit-island-life/" },
	{ label: "Bratz® x Blackbough", url: "/collections/bratz/" },
	...(!isGlobal ? [{ label: "Butter Yellow", url: "/collections/the-butter-yellow-collection/" }] : []),
]
